import {Flex, Text} from '@chakra-ui/react';
import {IconBlock, TitledSection} from 'components/layouts';
import {useTranslation} from 'hooks';
import React, {FC} from 'react';

interface Props {
  instructions: string;
}

export const OrderInstructions: FC<Props> = ({instructions}) => {
  const {t} = useTranslation();
  return (
    <TitledSection title={t('SPECIAL_MENTIONS')}>
      <IconBlock icon="">
        <Flex alignItems="center">
          <Text>{instructions}</Text>
        </Flex>
      </IconBlock>
    </TitledSection>
  );
};
